type Paths = string[];

export const generateRoutePath = (paths: Paths) => {
  return "/" + paths.join("/");
};
